import { ChangeDetectionStrategy, Component, inject, model, signal,} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSpinner, MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { PrintService } from '../../../shared/services/print-service';
import { MatIcon } from '@angular/material/icon';


@Component({
  selector: 'app-print-modal',
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatDatepickerModule,
    MatIcon,
    MatButtonModule,
    MatProgressSpinner
],
  templateUrl: './modal-print-link.html',
  styleUrl: './modal-print-link.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrintLinkComponentModal {
  readonly dialogRef = inject(MatDialogRef<PrintLinkComponentModal>);
  readonly data = inject<{id : string}>(MAT_DIALOG_DATA);
  // recupere les donnees envoyes par le parent
  printService = inject(PrintService)

  state = signal(false)

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.printService.printLoading.subscribe((res) => {
      console.log('state : ', res);
      
      this.state.update(val => res)
    })
  }
}
